import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Robot } from 'src/app/models/robot';

import { API } from '@aws-amplify/api';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ToggleHide } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { AmplifyServiceBuilder } from 'src/app/shared/utils/amplify.service.builder';
import { ENVIRONMENT } from 'src/environments/environment';
import {
  DeleteRobotsSuccess,
  LoadOwnerRobotsSuccess,
  LoadRobotsSuccess,
  SaveRobotComplete,
  SaveRobotFail
} from '../../../features/qa-testing/redux/qa.actions';

@Injectable({
  providedIn: 'any'
})
export class RobotsService {
  public username$: Observable<string> = inject(Store).select(RouterState.username);

  public owner: string;
  public signedRequests: any;
  public selectedKeys: string[] = [];
  public allKeys: string[] = [];
  public type = 'my robots';

  public robots: any;
  public robots_api = APIS.ROBOTS;

  constructor(private store: Store, private toastrService: NbToastrService) {
    this.username$.subscribe((data) => (this.owner = data));
  }

  public loadAllRobotsAmplify(reload?) {
    const requestData = AmplifyServiceBuilder(this.robots_api, true);

    API.get(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, requestData)
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, 'Fetching Robots Complete', {
            status: 'info'
          });
        }
        this.store.dispatch(new LoadRobotsSuccess(response));
      })
      .catch((error) => {
        this.store.dispatch(ToggleHide);
        this.toastrService.show(status, 'Failed to fetch robot list', { status: 'danger' });
        console.error('Error occured', error);
      });
  }

  public postRobotAmplify(newRobot: Robot, isEdit?: boolean) {
    const body = newRobot;
    const requestData = AmplifyServiceBuilder(this.robots_api, true, body);

    API.post(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, requestData)
      .then((response) => {
        this.store.dispatch(new SaveRobotComplete(isEdit, newRobot));
      })
      .catch((error) => {
        this.store.dispatch(new SaveRobotFail(error));
      });
  }

  public deleteRobotAmplify(robot: Robot) {
    const body = robot;
    const requestData = AmplifyServiceBuilder(this.robots_api, true, body);

    API.del(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, requestData)
      .then((response) => {
        this.store.dispatch(new DeleteRobotsSuccess(robot));
      })
      .catch((error) => {
        this.store.dispatch(new SaveRobotFail(error));
      });
  }

  public loadOwnerRobotsAmplify() {
    const queryStringParameters = {
      owner: this.owner
    };
    const requestData = AmplifyServiceBuilder(this.robots_api, true, false, queryStringParameters);

    API.get(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, requestData)
      .then((response) => {
        this.toastrService.show(status, 'Fetch owner robots complete', { status: 'success' });
        this.store.dispatch(new LoadOwnerRobotsSuccess(response));
      })
      .catch((error) => {
        this.toastrService.show(status, 'Failed to fetch owner robots', { status: 'danger' });
        this.store.dispatch(ToggleHide);
        console.error('Error occured', error);
      });
  }
}
